/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemARSourceFromJSON(json) {
    return WallItemARSourceFromJSONTyped(json, false);
}
export function WallItemARSourceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cameraPoseProvider': !exists(json, 'camera_pose_provider') ? undefined : json['camera_pose_provider'],
        'streemshotId': !exists(json, 'streemshot_id') ? undefined : json['streemshot_id'],
    };
}
export function WallItemARSourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'camera_pose_provider': value.cameraPoseProvider,
        'streemshot_id': value.streemshotId,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemARSourceCameraPoseProvider;
(function (WallItemARSourceCameraPoseProvider) {
    WallItemARSourceCameraPoseProvider["STREEMSHOTCAMERAPOSE"] = "STREEMSHOT_CAMERA_POSE";
    WallItemARSourceCameraPoseProvider["TWILIODATATRACK"] = "TWILIO_DATA_TRACK";
})(WallItemARSourceCameraPoseProvider || (WallItemARSourceCameraPoseProvider = {}));
//# sourceMappingURL=WallItemARSource.js.map